<template>
  <div v-if="show" class="rdw-warn d-flex mb-3" :class="{ 'rdw-warn--expanded': expanded }" role="button" tabindex="0" @click="expanded = !expanded" @keydown.enter="expanded = !expanded">
    <i class="fas fa-triangle-exclamation rdw-warn-icon"></i>
    <div class="rdw-warn-body">
      <div class="rdw-warn-title-row">
        <div class="rdw-warn-title">{{ $t('ReportBuilder.dateRange.hardcodedWarning.title') }}</div>
        <i class="fas fa-chevron-down rdw-warn-chevron"></i>
      </div>
      <p v-if="expanded" class="rdw-warn-text">{{ $t('ReportBuilder.dateRange.hardcodedWarning.text') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "_hardcodedDateWarning",
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    show() {
      return this.$store.state.ReportFromBuilder.hardcodedDateOnLoad;
    }
  }
}
</script>

<style scoped>
.rdw-warn {
  display: flex;
  gap: 11px;
  padding: 12px 14px;
  border-radius: var(--radius-lg, 12px);
  background: var(--c-warning-bg);
  border: 1px solid var(--c-warning-bd);
  cursor: pointer;
}
.rdw-warn-icon { color: var(--c-warning-fg); margin-top: 2px; }
.rdw-warn-body { flex: 1 1 auto; min-width: 0; }
.rdw-warn-title-row { display: flex; align-items: center; gap: 8px; }
.rdw-warn-title { flex: 1 1 auto; font: 700 13px 'Open Sans', system-ui, sans-serif; color: var(--ui-text-1); }
.rdw-warn-chevron {
  font-size: 11px;
  color: var(--c-warning-fg);
  transition: transform 0.15s;
}
.rdw-warn--expanded .rdw-warn-chevron { transform: rotate(180deg); }
.rdw-warn-text { font: 500 12px/1.5 'Open Sans', system-ui, sans-serif; color: var(--ui-text-2); margin: 6px 0 0; }
</style>
